import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Group 16",
  "use": "icon-Group 16-usage",
  "viewBox": "0 0 6 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 7\" id=\"icon-Group 16\">\n  <g id=\"icon-Group 16_Group_16\" data-name=\"Group 16\" transform=\"translate(-0.207 -0.004)\">\n    <path id=\"icon-Group 16_Polygon_3\" data-name=\"Polygon 3\" d=\"M3.5,0,7,6H0Z\" transform=\"translate(6.207 0.004) rotate(90)\" fill=\"currentColor\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Group 16.svg
// module id = Itfo
// module chunks = 3